export default "__VITE_ASSET__CUaFIxQF__"